module.exports = __webpack_public_path__ + "static/img/icon-mark.47b25c32.png";